(function (w, d) {
  'use strict';
  if (w.CPEnquiryRecovery) return;
  const bound = new WeakMap(), active = new Set();
  const clean = value => String(value == null ? '' : value).replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').trim();
  function init(root) {
    if (bound.has(root)) return;
    const box = root.querySelector('[data-cp-enquiry-recovery]');
    if (!box) return;
    let messages;
    try { messages = JSON.parse(box.querySelector('[data-recovery-messages]').textContent); } catch (_) { return; }
    const email = clean(box.dataset.email);
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) return;
    const panel = box.querySelector('[data-recovery-panel]'), text = box.querySelector('[data-recovery-text]');
    const status = box.querySelector('[data-recovery-status]'), mail = box.querySelector('[data-recovery-mail]');
    const controller = new AbortController(), options = { signal: controller.signal };
    let generation = 0, objectURL = '', expiry, delivery = null;
    function clearFile() {
      clearTimeout(expiry);
      if (objectURL) URL.revokeObjectURL(objectURL);
      objectURL = '';
      delivery?.remove(); delivery = null;
    }
    function invalidate() {
      generation++; clearFile();
      text.value = ''; panel.hidden = true; mail.removeAttribute('href');
      status.textContent = '';
    }
    function visibleDetails() {
      const parts = [messages.documentTitle, ''];
      for (const key of ['type','context','name','email','company','phone','postcode','region','equipment','serial']) {
        const field = root.querySelector('[data-enquiry-field="' + key + '"]');
        if (!field || field.disabled || !clean(field.value)) continue;
        const value = field.tagName === 'SELECT' ? field.selectedOptions[0]?.textContent : field.value;
        parts.push(messages[key] + ': ' + clean(value));
      }
      const summary = root.querySelector('[data-enquiry-field="summary"]');
      const note = root.querySelector('[data-enquiry-field="message"]');
      if (summary && !summary.disabled && clean(summary.value)) parts.push('', messages.requirements, clean(summary.value));
      if (note && !note.disabled && clean(note.value)) parts.push('', messages.notes, clean(note.value));
      const path = box.dataset.sourcePath;
      if (/^\/(?!\/)[^?#\u0000-\u0020]*$/.test(path || '')) parts.push('', messages.page + ': ' + path);
      parts.push('', messages.documentNotice);
      return parts.join('\n');
    }
    function record() {
      if (!w.CPEnquiry?.exportBrief) throw new Error('Source unavailable');
      return w.CPEnquiry.exportBrief(false);
    }
    function signature(value) {
      const copy = { ...value, journey: value.journey ? { ...value.journey } : undefined };
      delete copy.exportedAt;
      if (copy.journey) delete copy.journey.updated;
      return JSON.stringify(copy);
    }
    function offer(blob, filename, label) {
      if (!(blob instanceof Blob) || blob.size === 0) throw new Error('Empty download');
      clearFile();
      objectURL = URL.createObjectURL(blob);
      delivery = d.createElement('p'); delivery.className = 'cp-recovery__download'; delivery.setAttribute('role', 'status');
      const lead = d.createElement('span'); lead.textContent = messages.fileReady + ' ';
      const a = d.createElement('a'); a.href = objectURL; a.download = filename; a.textContent = label;
      a.dataset.cpPreparedDownload = '';
      delivery.append(lead, a); box.before(delivery);
      expiry = setTimeout(() => { clearFile(); status.textContent = messages.expired; }, 60000);
      a.click();
    }
    function prepare() {
      invalidate(); text.value = visibleDetails(); panel.hidden = false;
      const body = encodeURIComponent(text.value);
      const subject = encodeURIComponent(messages.subject);
      mail.href = 'mailto:' + email + '?subject=' + subject + (body.length <= 6000 ? '&body=' + body : '');
      status.textContent = body.length <= 6000 ? messages.emailPrepared : messages.longEmail;
      return text.value;
    }
    root.addEventListener('click', async event => {
      const button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (button.matches('[data-enquiry-clear],[data-enquiry-refresh],[data-enquiry-remove]')) { invalidate(); return; }
      if (!button.matches('[data-enquiry-export],[data-enquiry-pdf],[data-recovery-prepare],[data-recovery-copy],[data-recovery-download]')) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (button.disabled) return;
      if (button.matches('[data-recovery-prepare]')) { prepare(); return; }
      if (button.matches('[data-recovery-copy]')) {
        const value = prepare(), epoch = generation;
        try {
          if (!w.navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await w.navigator.clipboard.writeText(value);
          if (epoch === generation) status.textContent = messages.copied;
        } catch (_) {
          if (epoch === generation) { text.focus(); text.select(); status.textContent = messages.manualCopy; }
        }
        return;
      }
      if (button.matches('[data-recovery-download]')) {
        try { const value = prepare(); offer(new Blob([value], {type:'text/plain;charset=utf-8'}), 'Cafe-Perfection-Enquiry.txt', messages.saveText); }
        catch (_) { status.textContent = messages.fileError; }
        return;
      }
      invalidate(); const epoch = generation;
      if (button.matches('[data-enquiry-export]')) {
        try { offer(new Blob([JSON.stringify(record(), null, 2)], {type:'application/json'}), 'Cafe-Perfection-Planning-Brief.json', messages.saveJson); }
        catch (_) { status.textContent = messages.fileError; }
        return;
      }
      button.disabled = true;
      const progress = root.querySelector('[data-enquiry-status]');
      if (progress) progress.textContent = messages.preparing;
      try {
        if (!w.CPFinishedBrochure?.createPlanningPack) throw new Error('PDF unavailable');
        const source = record(), before = signature(source);
        const result = await w.CPFinishedBrochure.createPlanningPack(source);
        if (epoch !== generation || !root.isConnected || before !== signature(record())) {
          if (progress && root.isConnected) progress.textContent = messages.changed;
          return;
        }
        const blob = new Blob([result.bytes], {type:'application/pdf'});
        if (await blob.slice(0, 5).text() !== '%PDF-') throw new Error('Invalid PDF');
        if (epoch !== generation || !root.isConnected || before !== signature(record())) {
          if (progress && root.isConnected) progress.textContent = messages.changed;
          return;
        }
        offer(blob, 'Cafe-Perfection-Planning-Brief.pdf', messages.savePdf);
        if (progress) progress.textContent = messages.pdfPrepared;
      } catch (_) {
        if (epoch === generation && progress && root.isConnected) progress.textContent = messages.pdfError;
      } finally { button.disabled = false; }
    }, { ...options, capture: true });
    root.addEventListener('input', event => { if (event.target.matches('[data-enquiry-field]')) invalidate(); }, options);
    root.addEventListener('change', event => { if (event.target.matches('[data-enquiry-field]')) invalidate(); }, options);
    box.addEventListener('toggle', () => { if (!box.open) { text.value = ''; panel.hidden = true; mail.removeAttribute('href'); } }, options);
    const state = { root, clear: invalidate, dispose() { invalidate(); controller.abort(); active.delete(state); bound.delete(root); } };
    bound.set(root, state); active.add(state); box.dataset.ready = 'true';
  }
  function boot() {
    for (const state of active) if (!state.root.isConnected) state.dispose();
    d.querySelectorAll('[data-cp-enquiry-root]').forEach(init);
  }
  w.CPEnquiryRecovery = Object.freeze({ version: '2.18.19' });
  w.addEventListener('pagehide', () => { for (const state of active) state.clear(); });
  d.addEventListener('shopify:section:load', boot);
  d.addEventListener('shopify:section:unload', () => setTimeout(boot, 0));
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
})(window, document);
